import React, { useState, useCallback } from "react";
import { styled, Theme } from "@material-ui/core";
import PlayButtonIcon from "./icon";
import { motion, MotionProps } from "framer-motion";

const Button = styled(motion.button)(
  ({ theme, size, color }: { theme: Theme; size: string; color: string }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "none",
    zIndex: 10,
    padding: "1rem",
    border: 0,
    outline: 0,
    tapHighlightColor: "transparent",
    color: color || theme.palette.primary.main,
    "& > svg": {
      width: size || "75px",
      height: size || "75px"
    }
  })
);

/**
 * Play button for non-autoplay video cards
 * @param hideAfterClick Set to true to hide button after clicking. This allows us to not update the parent and prevent re-rendering the <video>
 */
const VideoPlayButton = ({
  onClick,
  hideAfterClick,
  size,
  color,
  ...props
}: {
  onClick?: () => void;
  hideAfterClick?: boolean;
  size?: string;
  color?: string;
} & MotionProps) => {
  const [hidden, setHidden] = useState(false);

  const onSelfHideClick = useCallback(() => {
    setHidden(true);
    onClick();
  }, [onClick, hideAfterClick]);

  if (hidden) {
    return null;
  }

  return (
    <Button
      onClick={hideAfterClick ? onSelfHideClick : onClick}
      title="Play video"
      size={size}
      color={color}
      {...props}
    >
      <PlayButtonIcon />
    </Button>
  );
};

export default VideoPlayButton;
